import React, { useState, useEffect, useRef } from "react";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import { getHumorLabelAndSummary } from "./humorUtils";

dayjs.extend(isToday);

export default function SidebarSummary({ sessionsForMonth, fullHeight = false }) {
  const sidebarRef = useRef(null);
  const todayRef = useRef(null);

  const sessionsByDate = {};
  sessionsForMonth.forEach(session => {
    const date = dayjs(session.Date).format("YYYY-MM-DD");
    if (!sessionsByDate[date]) sessionsByDate[date] = [];
    sessionsByDate[date].push(session);
  });

  const sortedDates = Object.keys(sessionsByDate).sort();
  const todayStr = dayjs().format("YYYY-MM-DD");

  const [expandedDates, setExpandedDates] = useState({});

  useEffect(() => {
    if (sessionsByDate[todayStr]) {
      setExpandedDates(prev => ({ ...prev, [todayStr]: true }));
    }
  }, [sessionsForMonth]);

  useEffect(() => {
    if (todayRef.current && sidebarRef.current) {
      const sidebar = sidebarRef.current;
      const todayElement = todayRef.current;

      const sidebarHeight = sidebar.offsetHeight;
      const todayTop = todayElement.offsetTop;
      const todayHeight = todayElement.offsetHeight;

      sidebar.scrollTop = todayTop - sidebarHeight / 2 + todayHeight / 2;
    }
  }, [expandedDates]);

  const toggleDate = (date) => {
    setExpandedDates(prev => ({
      ...prev,
      [date]: !prev[date],
    }));
  };

  return (
    <div
      ref={sidebarRef}
      className="p-3 bg-light border rounded sticky-top"
      style={{ top: "1rem", maxHeight: fullHeight ? "100vh" : "46vh", overflowY: "auto" }}
    >
      <h5 className="mb-3">Month at a Glance</h5>
      {sortedDates.map(date => {
        const sessions = sessionsByDate[date];
        const isExpanded = expandedDates[date];
        const isTodayDate = dayjs(date).isToday();
        const { label, summary } = getHumorLabelAndSummary(sessions);

        return (
          <div
            key={date}
            ref={isTodayDate ? todayRef : null}
            className={`mb-3 p-2 rounded ${isTodayDate ? 'bg-warning-subtle border border-warning' : 'bg-white'}`}
          >
            <div
              onClick={() => toggleDate(date)}
              className="d-flex justify-content-between align-items-center cursor-pointer"
              style={{ cursor: "pointer" }}
            >
              <div>
                <strong>{dayjs(date).format("MMM D (ddd)")}</strong>
                <div className="text-primary small">{label}</div>
              </div>
              <button className="btn btn-sm btn-outline-secondary">
                {isExpanded ? "−" : "+"}
              </button>
            </div>

            {isExpanded && (
              <div className="mt-2">
                <div className="text-muted small mb-2">{summary}</div>
                <ul className="list-unstyled small">
                  {sessions.map((s, idx) => (
                    <li key={idx} className="mb-1">
                      <strong>{s.Class}</strong> @ {s.Time} — <em>{s.Faculty}</em>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
